import { Box, Typography } from "@mui/material";
import NewBanner from "./NewBanner";

export interface AccessUnavailableProps {
  message?: string;
}

const AccessUnavailable = ({ message }: AccessUnavailableProps) => (
  <Box sx={{ p: 2 }}>
    <NewBanner titleLabel="Not Available" />
    <Typography
      variant="h6"
      component="div"
      sx={{ mb: 0.5, fontSize: "1.1rem" }}
    >
      {message || "This surface is not available for your current role or device."}
    </Typography>
  </Box>
);

export default AccessUnavailable;
